import ar from "./ar.json";
import cs from "./cs.json";
import en from "./en.json";
import es from "./es.json";
import el from "./el.json";
import fr from "./fr.json";
import de from "./de.json";
import it from "./it.json";
import pt from "./pt.json";
import ru from "./ru.json";
import sv from "./sv.json";
import zh from "./zh.json";

const resources = {
  ar: { translation: ar },
  cs: { translation: cs },
  en: { translation: en },
  es: { translation: es },
  el: { translation: el },
  fr: { translation: fr },
  de: { translation: de },
  it: { translation: it },
  pt: { translation: pt },
  ru: { translation: ru },
  sv: { translation: sv },
  zh: { translation: zh },
};

export default resources;